/**
 * @generated SignedSource<<eede2d30be93038e36807d286ae381ae>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserRecommendationsRecommendationTile_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BuyerProductTile_viewer" | "ItemHeartWrapper_viewer">;
  readonly " $fragmentType": "UserRecommendationsRecommendationTile_viewer";
};
export type UserRecommendationsRecommendationTile_viewer$key = {
  readonly " $data"?: UserRecommendationsRecommendationTile_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserRecommendationsRecommendationTile_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "fetchFavorites"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserRecommendationsRecommendationTile_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyerProductTile_viewer"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "loadPortfolioData",
          "variableName": "fetchFavorites"
        },
        {
          "items": [
            {
              "kind": "Variable",
              "name": "userIds.0",
              "variableName": "userId"
            }
          ],
          "kind": "ListValue",
          "name": "userIds"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ItemHeartWrapper_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "062b93a949a5d314f3ce96081c0f7880";

export default node;
